import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { postPpiTable } from '../actions';
import RaisedButton from 'material-ui/RaisedButton';
import CircularProgress from 'material-ui/CircularProgress';

const ProgressStyle = {
    marginTop: '20px'
};

function SaveBtn({ loading, postPpiTable }) {
    return (
        <RaisedButton
            label={loading ? <CircularProgress size={25} thickness={2} style={ProgressStyle} /> : 'Save'}
            disabled={loading}
            onClick={() => {
                postPpiTable();
            }}
        />
    );
}

SaveBtn.propTypes = {
    // From connect
    loading: PropTypes.bool,
    postPpiTable: PropTypes.func.isRequired
};

export default connect(
    null,
    // ({ makerToolPage: { pitchLineupLoading } = {} }) => ({ loading: pitchLineupLoading }),
    { postPpiTable }
)(SaveBtn);



/** WEBPACK FOOTER **
 ** ../src/dash/front/ppi/components/SaveBtn.js
 **/